import { PendingSpinnerTooltip } from "@/components/pending-change/PendingSpinnerTooltip.tsx";
import useCustomFieldsHook from "@/hooks/use-custom-fields.hook.tsx";
import { ApiTableRowPending } from "@/types/employees/employee.types.ts";
import { Stack } from "@skailer-com/uikit";
import { ReactNode } from "react";

interface PendingTableCellProps {
  children: ReactNode;
  pending: ApiTableRowPending;
}

export function PendingTableCell({ children, pending }: PendingTableCellProps) {
  const { renderPendingTooltipContent } = useCustomFieldsHook();

  return (
    <Stack
      className="w-fit whitespace-nowrap text-secondary"
      direction="horizontal"
      items="center"
      gap="xs"
    >
      <PendingSpinnerTooltip tooltip={renderPendingTooltipContent(pending.datetime_created_at)} />
      {children}
    </Stack>
  );
}
